import { render, staticRenderFns } from "./GlobalMenuDropDown.vue?vue&type=template&id=6ab85dbe&scoped=true&"
import script from "./GlobalMenuDropDown.vue?vue&type=script&lang=ts&"
export * from "./GlobalMenuDropDown.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalMenuDropDown.vue?vue&type=style&index=0&id=6ab85dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab85dbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
